import { render, staticRenderFns } from "./HxHistory.vue?vue&type=template&id=dbbbb15a&scoped=true&"
import script from "./HxHistory.vue?vue&type=script&lang=js&"
export * from "./HxHistory.vue?vue&type=script&lang=js&"
import style0 from "./HxHistory.vue?vue&type=style&index=0&id=dbbbb15a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbbb15a",
  null
  
)

export default component.exports